import React from 'react';
import { PlatformOverview } from '../features/platform';

export const Platform: React.FC = () => <PlatformOverview />;
